import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function UserDetailsSkeleton() {
    return (
        <Stack spacing={1} sx={{ margin: '20px' }}>
            <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
            <Skeleton variant="rounded" width={210} height={100} />
            <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Skeleton variant="text" sx={{ fontSize: '3rem' }} width={210} />
            </Stack>
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
        </Stack>
    );
}
